"use strict";

require("core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = RequestTimeoutException;
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.promise.js");
var _notificationsTimeout = _interopRequireDefault(require("./notificationsTimeout"));
var _unavailable = _interopRequireDefault(require("../../exceptions/unavailable"));
var _completeEnquiryTimeout = _interopRequireDefault(require("./completeEnquiryTimeout"));
var _completeInvestigateTimeout = _interopRequireDefault(require("./completeInvestigateTimeout"));
var _changeDecisionTimeout = _interopRequireDefault(require("./changeDecisionTimeout"));
var _unconfirmedPublishTimeout = _interopRequireDefault(require("./unconfirmedPublishTimeout"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function RequestTimeoutException(data) {
  switch (data.action) {
    case 'resolve_notifications':
      return Promise.reject(new _notificationsTimeout["default"](data));
    case 'reject_complete_enquiry':
      return Promise.reject(new _completeEnquiryTimeout["default"](data));
    case 'reject_complete_investigate':
      return Promise.reject(new _completeInvestigateTimeout["default"](data));
    case 'reject_change_decision':
      return Promise.reject(new _changeDecisionTimeout["default"](data));
    case 'unconfirmed_publish':
      return Promise.reject(new _unconfirmedPublishTimeout["default"](data));
    default:
      return Promise.reject(new _unavailable["default"](data));
  }
}